var Wai = function(p){


    var self = this;

    self.state = {

        context : {
            v : null,
            set value(_v){
                this.v = _v

                p.vm.$store.commit('context', this.v)

                if (this.v){

                }
            },

            get value(){
                return this.v
            }
        }
        
    }

    self.api = {
        context : function(){

            return p.api.app.context()
        }
    }
    
    self.init = function(){

        return self.api.context().then(context => {

            self.state.context.value = context
            
            return Promise.resolve()
        })
    }

    return self

}


export default Wai